export enum IconType {
  Github = "github",
  AntDesign = 1,
  Touri = 2,
  Remix = 3,
  FloatingUi = 4,
  Mui = 5,
  Electron = 6,
  NextJs = 7,
  TippyJs = 8,
}

interface IconProps {
  type: IconType;
  className?: string;
  color?: string;
}

function Icon({ type, className, color }: IconProps) {
  if (type === IconType.Github) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className={className}
      >
        <g clipPath="url(#clip0_336_37434)">
          <path
            d="M11.9893 0.328126C5.36518 0.325447 0 5.68795 0 12.3067C0 17.5406 3.35625 21.9897 8.03036 23.6237C8.65982 23.7817 8.56339 23.3344 8.56339 23.029V20.9531C4.92857 21.379 4.78125 18.9737 4.5375 18.5719C4.04464 17.7308 2.87946 17.5165 3.22768 17.1147C4.05536 16.6888 4.89911 17.2219 5.87679 18.6656C6.58393 19.7129 7.96339 19.5362 8.6625 19.3621C8.81518 18.7326 9.14196 18.1701 9.59196 17.7335C5.82589 17.0585 4.25625 14.7603 4.25625 12.0281C4.25625 10.7022 4.69286 9.48348 5.55 8.50045C5.00357 6.87991 5.60089 5.49241 5.68125 5.28616C7.2375 5.14688 8.85536 6.40045 8.98125 6.49956C9.86518 6.26116 10.875 6.13527 12.0054 6.13527C13.1411 6.13527 14.1536 6.26652 15.0455 6.50759C15.3482 6.27723 16.8482 5.20045 18.2946 5.3317C18.3723 5.53795 18.9563 6.89331 18.442 8.49241C19.3098 9.47813 19.7518 10.7076 19.7518 12.0362C19.7518 14.7737 18.1714 17.0746 14.3946 17.7388C14.7181 18.057 14.975 18.4364 15.1502 18.8549C15.3254 19.2734 15.4155 19.7226 15.4152 20.1763V23.1897C15.4366 23.4308 15.4152 23.6692 15.817 23.6692C20.5607 22.0701 23.9759 17.5888 23.9759 12.3094C23.9759 5.68795 18.608 0.328126 11.9893 0.328126Z"
            fill={color || "black"}
            fillOpacity="0.85"
          />
        </g>
        <defs>
          <clipPath id="clip0_336_37434">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (type === IconType.AntDesign) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        className={className}
      >
        <path
          d="M14.6546 0.668111L0.669362 14.6419C0.490629 14.82 0.348812 15.0316 0.252046 15.2646C0.15528 15.4976 0.105469 15.7475 0.105469 15.9998C0.105469 16.2521 0.15528 16.5019 0.252046 16.735C0.348812 16.968 0.490629 17.1796 0.669362 17.3577L14.6546 31.3315C14.833 31.5101 15.0449 31.6518 15.2781 31.7485C15.5113 31.8452 15.7613 31.895 16.0138 31.895C16.2662 31.895 16.5162 31.8452 16.7494 31.7485C16.9826 31.6518 17.1945 31.5101 17.3729 31.3315L23.2366 25.4726C23.91 24.7998 23.91 23.7089 23.2366 23.0361C22.5633 22.3633 21.4716 22.3633 20.7982 23.0361L16.3529 27.4777C16.1657 27.6647 15.8817 27.6647 15.6946 27.4777L4.52632 16.3187C4.33912 16.1316 4.33912 15.8479 4.52632 15.6611L15.6946 4.50187C15.8818 4.31483 16.1657 4.31483 16.3529 4.50187L20.7982 8.94347C21.4716 9.61627 22.5633 9.61627 23.2366 8.94347C23.91 8.27067 23.91 7.17995 23.2366 6.50715L17.3735 0.648751C16.6185 -0.0862893 15.4036 -0.0803694 14.6546 0.667951V0.668111Z"
          fill="url(#paint0_linear_412_38335)"
        />
        <path
          d="M14.6546 0.668111L0.669362 14.6419C0.490629 14.82 0.348812 15.0316 0.252046 15.2646C0.15528 15.4976 0.105469 15.7475 0.105469 15.9998C0.105469 16.2521 0.15528 16.5019 0.252046 16.735C0.348812 16.968 0.490629 17.1796 0.669362 17.3577L14.6546 31.3315C14.833 31.5101 15.0449 31.6518 15.2781 31.7485C15.5113 31.8452 15.7613 31.895 16.0138 31.895C16.2662 31.895 16.5162 31.8452 16.7494 31.7485C16.9826 31.6518 17.1945 31.5101 17.3729 31.3315L23.2366 25.4726C23.91 24.7998 23.91 23.7089 23.2366 23.0361C22.5633 22.3633 21.4716 22.3633 20.7982 23.0361L16.3529 27.4777C16.1657 27.6647 15.8817 27.6647 15.6946 27.4777L4.52632 16.3187C4.33912 16.1316 4.33912 15.8479 4.52632 15.6611L15.6946 4.50187C16.1606 4.10027 16.9209 3.28651 18.0374 3.09611C18.8671 2.95483 19.7742 3.26603 20.7588 4.03003L17.3734 0.648751C16.6183 -0.0862893 15.4034 -0.0803694 14.6545 0.667951L14.6546 0.668111Z"
          fill="url(#paint1_linear_412_38335)"
        />
        <path
          d="M24.59 21.7368C25.2633 22.4096 26.355 22.4096 27.0284 21.7368L31.3538 17.4148C32.1058 16.6635 32.1058 15.45 31.3538 14.699L26.9906 10.355C26.3158 9.683 25.2238 9.6838 24.55 10.3571C23.8766 11.0299 23.8766 12.1206 24.55 12.7934L27.4969 15.7379C27.6841 15.9249 27.6841 16.2088 27.4969 16.3956L24.59 19.3003C23.9166 19.9731 23.9166 21.064 24.59 21.7368Z"
          fill="url(#paint2_linear_412_38335)"
        />
        <path
          d="M16.0826 19.8428C18.1681 19.8428 19.8586 18.1536 19.8586 16.0698C19.8586 13.9861 18.1681 12.2969 16.0826 12.2969C13.9972 12.2969 12.3066 13.9861 12.3066 16.0698C12.3066 18.1536 13.9972 19.8428 16.0826 19.8428Z"
          fill="url(#paint3_linear_412_38335)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_412_38335"
            x1="14.784"
            y1="0.10205"
            x2="28.0742"
            y2="8.2182"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4285EB" />
            <stop offset="1" stop-color="#2EC7FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_412_38335"
            x1="16.5666"
            y1="0.102051"
            x2="10.0026"
            y2="34.0271"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#29CDFF" />
            <stop offset="0.3786" stop-color="#148EFF" />
            <stop offset="1" stop-color="#0A60FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_412_38335"
            x1="29.5316"
            y1="8.24411"
            x2="20.9908"
            y2="21.6014"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FA816E" />
            <stop offset="0.41473" stop-color="#F74A5C" />
            <stop offset="1" stop-color="#F51D2C" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_412_38335"
            x1="17.4517"
            y1="9.60366"
            x2="14.6098"
            y2="20.9715"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FA8E7D" />
            <stop offset="0.51264" stop-color="#F74A5C" />
            <stop offset="1" stop-color="#F51D2C" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === IconType.Touri) {
    return (
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        className={className}
      >
        <path
          d="M26.9559 44.3589C29.2752 43.5422 30.4932 40.9999 29.6765 38.6807C28.8597 36.3614 26.3175 35.1434 23.9982 35.9601C21.679 36.7769 20.4609 39.3191 21.2777 41.6384C22.0944 43.9576 24.6366 45.1757 26.9559 44.3589Z"
          fill="url(#paint0_linear_336_37414)"
        />
        <path
          d="M36.9266 27.0562C39.2458 26.2394 40.4639 23.6972 39.6471 21.3779C38.8304 19.0587 36.2882 17.8407 33.9689 18.6574C31.6497 19.4741 30.4316 22.0164 31.2484 24.3356C32.0651 26.6549 34.6073 27.8729 36.9266 27.0562Z"
          fill="url(#paint1_linear_336_37414)"
        />
        <path
          d="M16.7521 12.6054C14.7514 16.0924 13.7619 20.068 13.8946 24.0861C14.0273 28.1041 15.277 32.0057 17.5034 35.3532C17.6134 35.5499 17.762 35.7222 17.9404 35.8599C18.1188 35.9976 18.3232 36.0977 18.5413 36.1543C18.7595 36.2108 18.9868 36.2227 19.2096 36.1891C19.4324 36.1554 19.6461 36.0771 19.8378 35.9586C20.0295 35.8402 20.1953 35.6842 20.3251 35.5C20.455 35.3159 20.5462 35.1073 20.5932 34.887C20.6403 34.6666 20.6423 34.439 20.599 34.2178C20.5558 33.9967 20.4682 33.7866 20.3416 33.6002C18.7731 31.2762 17.7588 28.6232 17.3768 25.8456C16.9948 23.068 17.2554 20.2397 18.1384 17.5786C19.0214 14.9175 20.5033 12.4945 22.47 10.4962C24.4367 8.4979 26.8358 6.97759 29.4825 6.05232C31.7552 5.25099 34.1637 4.90583 36.57 5.03662C38.9763 5.16741 41.3331 5.77159 43.5056 6.81453C45.6781 7.85747 47.6235 9.3187 49.2304 11.1145C50.8373 12.9104 52.0743 15.0056 52.8703 17.2802C53.8809 20.1396 54.1658 23.2052 53.6997 26.2019C53.2336 29.1986 52.0309 32.0328 50.1996 34.4502C48.3683 36.8676 45.9655 38.7927 43.2069 40.0527C40.4483 41.3127 37.4201 41.8684 34.3938 41.6697C33.951 41.6476 33.5176 41.8022 33.1888 42.0997C32.86 42.3971 32.6629 42.813 32.6408 43.2558C32.6186 43.6986 32.7733 44.1321 33.0707 44.4608C33.3682 44.7896 33.7841 44.9867 34.2268 45.0089C37.7962 45.2229 41.3631 44.5518 44.6106 43.0552C47.858 41.5586 50.6854 39.2828 52.8414 36.4301C54.9974 33.5775 56.4152 30.2364 56.9688 26.7038C57.5224 23.1711 57.1947 19.5564 56.0147 16.181C54.6307 12.2697 52.1546 8.83709 48.8798 6.28968C45.6051 3.74227 41.6687 2.18684 37.5372 1.80765C33.4056 1.42846 29.2519 2.2414 25.5682 4.15016C21.8844 6.05892 18.8249 8.98352 16.7521 12.5775V12.6054Z"
          fill="url(#paint2_linear_336_37414)"
        />
        <path
          d="M6.77576 29.8854C5.22584 32.5822 4.27563 35.5815 3.98991 38.6787C3.70419 41.776 4.08969 44.8985 5.12012 47.8333C7.03042 53.2561 11.0143 57.6994 16.1973 60.1879C21.3804 62.6764 27.339 63.0067 32.7653 61.1063C35.8726 60.0102 38.6896 58.221 41.0026 55.8744C43.3156 53.5278 45.064 50.6853 46.1152 47.5626C47.1664 44.4398 47.4929 41.1187 47.0697 37.851C46.6466 34.5833 45.4851 31.4549 43.6732 28.7028C43.5351 28.4383 43.3287 28.2156 43.0754 28.0579C42.8221 27.9003 42.5311 27.8133 42.2328 27.8062C41.9345 27.7991 41.6398 27.8721 41.3792 28.0176C41.1187 28.163 40.9019 28.3756 40.7514 28.6333C40.5944 28.9035 40.5164 29.2123 40.5262 29.5247C40.536 29.8371 40.6334 30.1404 40.8071 30.4002C42.3756 32.7242 43.3899 35.3771 43.7719 38.1548C44.1539 40.9324 43.8933 43.7607 43.0103 46.4218C42.1273 49.0829 40.6454 51.5059 38.6787 53.5042C36.712 55.5025 34.3129 57.0228 31.6662 57.948C29.3945 58.7516 26.9865 59.0989 24.5803 58.9699C22.1741 58.8409 19.8171 58.2382 17.6443 57.1964C15.4715 56.1546 13.5257 54.6942 11.9185 52.8988C10.3113 51.1035 9.07427 49.0085 8.27837 46.7341C7.26429 43.8677 6.97946 40.794 7.44954 37.79C7.91963 34.786 9.12985 31.9462 10.9711 29.5266C12.8124 27.107 15.2269 25.1836 17.9969 23.9298C20.7669 22.676 23.8053 22.1312 26.8384 22.3446C27.2175 22.3758 27.596 22.2765 27.911 22.0633C28.2261 21.8501 28.4589 21.5357 28.5709 21.1721C28.6829 20.8086 28.6674 20.4176 28.5269 20.0641C28.3864 19.7106 28.1294 19.4156 27.7984 19.2281C27.5146 19.0692 27.1906 18.9966 26.8662 19.0194C22.8351 18.7726 18.8155 19.6613 15.2641 21.5845C11.7128 23.5078 8.77195 26.3885 6.77576 29.8994V29.8854Z"
          fill="url(#paint3_linear_336_37414)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_336_37414"
            x1="23.0163"
            y1="43.837"
            x2="27.4781"
            y2="36.109"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0096F2" />
            <stop offset="1" stopColor="#4CFFC4" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_336_37414"
            x1="37.7037"
            y1="19.1393"
            x2="33.2512"
            y2="26.8512"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF8A11" />
            <stop offset="1" stopColor="#FFF550" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_336_37414"
            x1="37.3066"
            y1="0.803466"
            x2="16.352"
            y2="37.098"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF8A11" />
            <stop offset="1" stopColor="#FFF550" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_336_37414"
            x1="12.6131"
            y1="58.6175"
            x2="33.568"
            y2="22.3225"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0096F2" />
            <stop offset="1" stopColor="#4CFFC4" />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === IconType.Remix) {
    return (
      <svg
        width="28"
        height="32"
        viewBox="0 0 28 32"
        fill="none"
        className={className}
      >
        <g filter="url(#filter0_ii_412_38342)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.5844 24.6779C26.8719 28.3751 26.8719 30.1084 26.8719 32H18.3178C18.3178 31.5873 18.3246 31.2112 18.3327 30.8289C18.3557 29.6403 18.38 28.4015 18.1872 25.899C17.9329 22.2356 16.3552 21.4211 13.4542 21.4211H0V14.7559H13.8615C17.5256 14.7559 19.3576 13.6409 19.3576 10.6899C19.3576 8.09472 17.5256 6.52245 13.8615 6.52245H0V0H15.3884C23.6827 0 27.8055 3.9178 27.8055 10.1764C27.8055 14.858 24.9045 17.9105 20.986 18.4193C24.2943 19.0809 26.2278 20.963 26.5844 24.6772V24.6779Z"
            fill="#E8F2FF"
          />
          <path
            d="M0 31.9999V27.0308H9.04524C10.5559 27.0308 10.8841 28.1518 10.8841 28.8195V31.9999H0Z"
            fill="#E8F2FF"
          />
        </g>
        <defs>
          <filter
            id="filter0_ii_412_38342"
            x="0"
            y="0"
            width="27.8047"
            height="32"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="28" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.223529 0 0 0 0 0.572549 0 0 0 0 1 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_412_38342"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="32" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.223529 0 0 0 0 0.572549 0 0 0 0 1 0 0 0 0.9 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_innerShadow_412_38342"
              result="effect2_innerShadow_412_38342"
            />
          </filter>
        </defs>
      </svg>
    );
  }

  if (type === IconType.FloatingUi) {
    return (
      <svg
        width="64"
        height="64"
        viewBox="0 0 271 320"
        fill="none"
        className={className}
      >
        <rect
          width="271"
          height="228"
          rx="50"
          fill="url(#logo_svg__paint0_linear_30:7)"
        ></rect>
        <circle cx="75" cy="110" r="20" fill="#333"></circle>
        <circle cx="196" cy="110" r="20" fill="#333"></circle>
        <mask
          id="logo_svg__a"
          maskUnits="userSpaceOnUse"
          x="75"
          y="76"
          width="121"
          height="121"
        >
          <circle cx="135.5" cy="136.5" r="60.5" fill="#333"></circle>
        </mask>
        <g mask="url(#logo_svg__a)">
          <path fill="#333" d="M0 152h263v89H0z"></path>
        </g>
        <path
          d="M135.5 274l-52.394-54.75h104.789L135.5 274z"
          fill="#E5EAF2"
        ></path>
        <defs>
          <linearGradient
            id="logo_svg__paint0_linear_30:7"
            x1="135.5"
            y1="0"
            x2="135.5"
            y2="228"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#fff"></stop>
            <stop offset="1" stop-color="#E5EAF2"></stop>
          </linearGradient>
        </defs>
      </svg>
    );
  }

  if (type === IconType.Mui) {
    return (
      <svg
        width="36"
        height="32"
        viewBox="0 0 36 32"
        fill="none"
        className={className}
      >
        <path
          d="M30.343 21.976a1 1 0 00.502-.864l.018-5.787a1 1 0 01.502-.864l3.137-1.802a1 1 0 011.498.867v10.521a1 1 0 01-.502.867l-11.839 6.8a1 1 0 01-.994.001l-9.291-5.314a1 1 0 01-.504-.868v-5.305c0-.006.007-.01.013-.007.005.003.012 0 .012-.007v-.006c0-.004.002-.008.006-.01l7.652-4.396c.007-.004.004-.015-.004-.015a.008.008 0 01-.008-.008l.015-5.201a1 1 0 00-1.5-.87l-5.687 3.277a1 1 0 01-.998 0L6.666 9.7a1 1 0 00-1.499.866v9.4a1 1 0 01-1.496.869l-3.166-1.81a1 1 0 01-.504-.87l.028-16.43A1 1 0 011.527.86l10.845 6.229a1 1 0 00.996 0L24.21.86a1 1 0 011.498.868v16.434a1 1 0 01-.501.867l-5.678 3.27a1 1 0 00.004 1.735l3.132 1.783a1 1 0 00.993-.002l6.685-3.839zM31 7.234a1 1 0 001.514.857l3-1.8A1 1 0 0036 5.434V1.766A1 1 0 0034.486.91l-3 1.8a1 1 0 00-.486.857v3.668z"
          fill="#007FFF"
        />
      </svg>
    );
  }

  if (type === IconType.Electron) {
    return (
      <svg width="64" height="64" viewBox="0 0 150 150" className={className}>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1.000000, -1.000000)" fill="#47848F">
            <g transform="translate(0.699997, 0.400002)">
              <path d="M49.1266117,32.7678207 C29.6225024,29.215471 14.2013759,32.9334829 8.05524688,43.5788906 C3.46886775,51.5227323 4.77984702,62.0549428 11.2346334,73.313229 C11.784031,74.2714753 13.0062179,74.6029127 13.9644642,74.0535151 C14.9227105,73.5041175 15.2541479,72.2819306 14.7047503,71.3236842 C8.89020489,61.1820912 7.75877926,52.0923876 11.5193485,45.5788906 C16.6249641,36.7357049 30.3803417,33.4193028 48.4098692,36.7030819 C49.4965616,36.9010048 50.5379481,36.1805149 50.735871,35.0938225 C50.933794,34.0071302 50.2133041,32.9657437 49.1266117,32.7678207 L49.1266117,32.7678207 Z M21.3774192,86.9975982 C29.2637932,95.6641388 39.5095099,103.792918 51.1941736,110.539062 C79.4867375,126.873781 109.60617,131.239854 124.450276,121.118296 C125.362885,120.496027 125.598252,119.251763 124.975984,118.339154 C124.353715,117.426545 123.10945,117.191177 122.196841,117.813446 C108.911542,126.872121 80.3002617,122.724668 53.1941736,107.07496 C41.8587362,100.530443 31.9375168,92.6591138 24.3358707,84.3054681 C23.5924595,83.4885142 22.3275337,83.4288961 21.5105799,84.1723074 C20.6936261,84.9157186 20.634008,86.1806443 21.3774192,86.9975982 L21.3774192,86.9975982 Z"></path>
              <path d="M119.715028,84.5645564 C132.485847,69.4778279 136.944975,54.3039723 130.811502,43.6804851 C126.298377,35.8635227 116.757502,31.7364946 104.07783,31.5715943 C102.973354,31.5572305 102.066355,32.4409411 102.051991,33.5454172 C102.037627,34.6498933 102.921338,35.5568923 104.025814,35.5712561 C115.42958,35.7195631 123.64924,39.2750828 127.3474,45.6804851 C132.441983,54.504561 128.465433,68.0362633 116.661994,81.980183 C115.948339,82.823255 116.053252,84.0852315 116.896324,84.7988865 C117.739396,85.5125415 119.001373,85.4076283 119.715028,84.5645564 L119.715028,84.5645564 Z M86.8941729,33.4337961 C75.3472476,35.9077753 63.0565872,40.7449031 51.2528293,47.5598059 C22.0460997,64.4223191 2.99388753,89.2866992 5.63992146,107.315628 C5.80031644,108.40849 6.81628192,109.164404 7.90914387,109.004009 C9.00200581,108.843614 9.75791963,107.827648 9.59752465,106.734786 C7.24812559,90.7269991 25.3077559,67.1580032 53.2528293,51.0239075 C64.7034124,44.4129103 76.6040539,39.7292788 87.732172,37.3450308 C88.8122297,37.1136238 89.5001969,36.0504715 89.2687899,34.9704139 C89.0373828,33.8903562 87.9742306,33.202389 86.8941729,33.4337961 L86.8941729,33.4337961 Z"></path>
              <path d="M39.5781566,119.814969 C46.2553365,138.460057 57.1791975,149.939723 69.4627023,149.939723 C78.4212923,149.939723 86.7097444,143.832927 93.173031,133.08146 C93.7421303,132.134782 93.4360422,130.906001 92.4893639,130.336902 C91.5426857,129.767803 90.3139052,130.073891 89.7448058,131.020569 C83.9362601,140.682896 76.8014285,145.939723 69.4627023,145.939723 C59.2591023,145.939723 49.5159822,135.700874 43.3439572,118.46636 C42.9715492,117.426463 41.8266497,116.885356 40.7867525,117.257764 C39.7468554,117.630172 39.2057486,118.775072 39.5781566,119.814969 L39.5781566,119.814969 Z M100.569304,116.167782 C104.025952,105.121643 105.882448,92.3789056 105.882448,79.1002312 C105.882448,45.9661542 94.2856748,17.4033342 77.7676045,10.0688089 C76.758081,9.62054985 75.5763148,10.0755445 75.1280557,11.0850679 C74.6797966,12.0945914 75.1347913,13.2763576 76.1443147,13.7246167 C90.8764366,20.2661265 101.882448,47.373902 101.882448,79.1002312 C101.882448,91.9827075 100.084575,104.323064 96.7518499,114.973193 C96.4219733,116.027354 97.0091217,117.149338 98.0632826,117.479214 C99.1174435,117.809091 100.239428,117.221943 100.569304,116.167782 L100.569304,116.167782 Z"></path>
              <path d="M138.23701,114.208372 C138.23701,108.921713 133.951325,104.636028 128.664666,104.636028 C123.378006,104.636028 119.092321,108.921713 119.092321,114.208372 C119.092321,119.495032 123.378006,123.780716 128.664666,123.780716 C133.951325,123.780716 138.23701,119.495032 138.23701,114.208372 L138.23701,114.208372 Z M134.23701,114.208372 C134.23701,117.285893 131.742186,119.780716 128.664666,119.780716 C125.587145,119.780716 123.092321,117.285893 123.092321,114.208372 C123.092321,111.130852 125.587145,108.636028 128.664666,108.636028 C131.742186,108.636028 134.23701,111.130852 134.23701,114.208372 L134.23701,114.208372 Z"></path>
              <path d="M10.1230622,123.780716 C15.4097219,123.780716 19.6954063,119.495032 19.6954063,114.208372 C19.6954063,108.921713 15.4097219,104.636028 10.1230622,104.636028 C4.83640249,104.636028 0.550718038,108.921713 0.550718038,114.208372 C0.550718038,119.495032 4.83640249,123.780716 10.1230622,123.780716 L10.1230622,123.780716 Z M10.1230622,119.780716 C7.04554149,119.780716 4.55071804,117.285893 4.55071804,114.208372 C4.55071804,111.130852 7.04554149,108.636028 10.1230622,108.636028 C13.2005829,108.636028 15.6954063,111.130852 15.6954063,114.208372 C15.6954063,117.285893 13.2005829,119.780716 10.1230622,119.780716 L10.1230622,119.780716 Z"></path>
              <path d="M69.4627023,19.8330832 C74.749362,19.8330832 79.0350464,15.5473987 79.0350464,10.2607391 C79.0350464,4.97407937 74.749362,0.688394921 69.4627023,0.688394921 C64.1760426,0.688394921 59.8903582,4.97407937 59.8903582,10.2607391 C59.8903582,15.5473987 64.1760426,19.8330832 69.4627023,19.8330832 L69.4627023,19.8330832 Z M69.4627023,15.8330832 C66.3851816,15.8330832 63.8903582,13.3382597 63.8903582,10.2607391 C63.8903582,7.18321837 66.3851816,4.68839492 69.4627023,4.68839492 C72.540223,4.68839492 75.0350464,7.18321837 75.0350464,10.2607391 C75.0350464,13.3382597 72.540223,15.8330832 69.4627023,15.8330832 L69.4627023,15.8330832 Z"></path>
              <path d="M70.9248064,85.8696781 C67.1859596,86.677522 63.5024446,84.3014176 62.6930199,80.5625709 C61.8867569,76.8237241 64.2612803,73.1402091 68.0001271,72.3307843 C71.7389739,71.5229405 75.4224889,73.8990448 76.2319137,77.6378916 C77.0397575,81.3767383 74.6636532,85.0602533 70.9248064,85.8696781 Z"></path>
            </g>
          </g>
        </g>
      </svg>
    );
  }

  if (type === IconType.NextJs) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        className={className}
      >
        <path
          d="m22.43.01-.73.07C14.88.69 8.5 4.37 4.45 10.02A23.75 23.75 0 0 0 .22 20.51a18.3 18.3 0 0 0-.22 3.5c0 1.78.02 2.17.22 3.49A24.1 24.1 0 0 0 21.7 47.94c.73.08 3.87.08 4.6 0a24.22 24.22 0 0 0 8.65-2.53c.4-.2.49-.27.43-.31-.03-.03-1.8-2.4-3.9-5.24l-3.84-5.19-4.81-7.11a688.2 688.2 0 0 0-4.84-7.12c-.02 0-.04 3.16-.05 7.02-.02 6.76-.02 7.04-.1 7.2a.85.85 0 0 1-.42.42c-.15.08-.28.1-.99.1h-.81l-.22-.15a.88.88 0 0 1-.31-.34l-.1-.2.01-9.42.02-9.4.14-.19c.08-.1.24-.22.35-.29.19-.09.27-.1 1.08-.1.95 0 1.11.04 1.36.31.07.08 2.68 4 5.8 8.72l9.46 14.34 3.8 5.76.2-.13c1.7-1.1 3.5-2.68 4.92-4.32a23.89 23.89 0 0 0 5.65-12.27c.2-1.32.22-1.7.22-3.5 0-1.78-.02-2.17-.22-3.49A24.1 24.1 0 0 0 26.37.07c-.45-.04-3.55-.1-3.94-.06zm9.82 14.52a.95.95 0 0 1 .48.55c.03.12.04 2.73.03 8.61v8.44l-1.5-2.28-1.49-2.28v-6.14c0-3.96.02-6.19.05-6.3a.96.96 0 0 1 .46-.59c.2-.1.26-.1 1-.1.7 0 .82 0 .97.09z"
          fill="#000"
        />
      </svg>
    );
  }

  if (type === IconType.TippyJs) {
    return (
      <svg
        width="64"
        height="64"
        viewBox="0 0 225 200"
        fill-rule="evenodd"
        clip-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="1.5"
        className={className}
      >
        <path
          d="M144.8 161.2c2-2 2-5.3 0-7.3L117 126c-2-2-5.3-2-7.3 0l-27.8 28c-2 2-2 5.2 0 7.2l27.8 27.9c2 2 5.3 2 7.3 0l28-28z"
          fill="#a1ffee"
        />
        <path
          d="M113.5 119.4h1.2l.3.1h.2l.3.1h.2l.3.1.2.1h.2l.3.2h.2l.2.1.3.1.2.1h.1l.1.1.1.1h.2v.1h.2v.1l.2.1h.1l.1.1.1.1h.1l.1.2h.1l.2.1.2.2.2.1.2.2.2.1v.1l.2.1v.1l.2.1 28 28 .1.2h.1l.1.2.2.2.1.2h.1l.1.2.2.2.1.2.2.2v.2l.2.1v.2l.1.2h.1v.2h.1v.2l.2.2v.1l.1.2.1.2v.2l.2.3v.2l.1.2v.3l.2.2v.5l.1.2v.5l.1.3v2.4l-.1.3v.5l-.1.2-.1.2v.3l-.1.2-.1.3-.1.2-.1.2-.1.2v.2h-.1l-.1.3v.1l-.1.1-.2.3-.1.3-.1.1v.1l-.1.1-.1.1v.1l-.2.1v.1l-.1.1-.1.1v.1l-.2.1v.1l-.2.2-.1.1v.1l-.2.1v.1l-28.1 28.1-.1.1h-.1l-.1.2h-.1l-.1.1-.1.1-.1.1-.1.1h-.1l-.1.2h-.1l-.1.1h-.2v.2h-.2v.1h-.2v.1l-.2.1h-.1l-.1.1h-.1l-.1.1-.2.1-.2.1h-.1l-.1.1h-.1l-.3.2h-.2l-.2.1-.3.1-.2.1h-.2l-.3.1h-.2l-.3.1h-.2l-.3.1h-.4l-.3.1h-2.2l-.2-.1h-.3l-.2-.1h-.3l-.2-.1-.2-.1h-.3l-.2-.2h-.3l-.2-.1-.2-.1h-.1l-.1-.1h-.2v-.1h-.2l-.1-.2h-.2l-.1-.1-.1-.1h-.2v-.1l-.2-.1-.2-.1v-.1h-.2l-.1-.2h-.1l-.1-.1-.1-.1h-.1l-.1-.2h-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.2-.2-27.9-27.9-.2-.2-.1-.2h-.1l-.1-.2h-.1v-.2h-.2v-.2h-.1l-.1-.2-.2-.2-.1-.2v-.1l-.1-.1-.1-.1v-.1l-.1-.1v-.1l-.2-.2v-.2h-.1v-.2l-.1-.1v-.1l-.1-.2-.1-.2-.1-.2-.1-.3-.1-.2v-.2l-.1-.3-.1-.2v-.2l-.1-.3v-.5l-.1-.2v-3l.1-.2v-.2l.1-.3v-.2l.1-.3.1-.2v-.2l.2-.3v-.2l.2-.2v-.2l.1-.2v-.1l.1-.1v-.1l.1-.1.1-.1v-.2h.1l.1-.2.1-.2.1-.1v-.1l.1-.1.1-.1.1-.1v-.1l.2-.1v-.1l.1-.1.1-.1v-.1l.2-.1v-.1l.1-.1.1-.1.1-.1.1-.1 28-28h.1l.1-.2.2-.2.2-.1v-.1h.2v-.2h.2l.1-.1.1-.1h.1l.1-.1.1-.1h.1l.1-.2h.3v-.2h.2l.2-.1.1-.1h.1l.1-.1h.2v-.1h.2l.2-.2h.2l.3-.1.2-.1h.3l.2-.2h.5l.2-.1h.3l.2-.1h.7l.3-.1h.7zm-.2 10.3-27.9 27.8 27.9 28 27.9-28-28-27.8z"
          fill="#253b59"
        />
        <path
          d="M210 24.9c0-8.8-6.5-15.9-14.6-15.9H24.6C16.6 9 10 16.1 10 24.9v127.2c0 8.8 6.5 15.9 14.6 15.9h170.8c8 0 14.6-7.1 14.6-15.9V24.9z"
          fill="url(#a)"
          stroke="#243a59"
          stroke-width="10.4"
          transform="matrix(1 0 0 .91824 3.3 6.8)"
        />
        <path
          d="M26 20.3v135.5a9.6 9.6 0 0 1-7.7-9.3v-117c0-4.5 3.3-8.3 7.7-9.2z"
          fill="#fff"
          fill-opacity=".9"
        />
        <ellipse
          cx="76.3"
          cy="78.9"
          rx="9"
          ry="8.9"
          fill="#243a59"
          transform="matrix(1.11111 0 0 1.12246 -9.8 -2.5)"
        />
        <ellipse
          cx="145.2"
          cy="78.9"
          rx="9"
          ry="8.9"
          fill="#243a59"
          transform="matrix(1.11111 0 0 1.12246 -10 -2.5)"
        />
        <path
          d="M141 110.5h.7l.3.2h.3l.3.2.3.1.3.2.2.1.3.2.2.2.3.2.2.3.2.2.2.3.1.3.2.3.1.2.1.4.1.3v.3l.1.3v1.6l-.1.3-.1.3-.1.3-.1.3-.2.3-.2.3-.2.2-.2.3-.2.2-.2.2-.3.2-.3.3-.4.3-.4.2-.4.3-.3.3-.4.2-.4.3-.4.2-.3.3-.4.2-.4.3-.3.2-.4.2-.4.3-.3.2-.4.2-.4.2-.4.2-.3.3-.4.2-.4.2-.3.2-.4.2-.3.1-.4.2-.4.2-.3.2-.4.2-.4.1-.3.2-.4.2-.4.1-.3.2-.4.1-.3.2-.4.1-.4.2-.3.1-.4.2-.3.1-.4.1-.3.2h-.4l-.3.2-.4.1-.3.1-.4.1-.3.1-.4.1-.3.1-.4.1-.3.1-.4.1-.3.1-.4.1h-.3l-.4.2h-.3l-.3.1h-.4l-.3.1-.4.1h-.3l-.3.1h-.4l-.3.1h-.3l-.4.1h-.3l-.3.1h-.7l-.3.1h-1l-.3.1h-6.5l-.3-.1h-.6l-.3-.1h-.6l-.3-.1h-.3l-.2-.1h-.3l-.3-.1h-.3l-.3-.1h-.2l-.3-.1h-.3l-.3-.1h-.2l-.3-.1h-.3l-.2-.2h-.6l-.2-.1-.3-.1h-.2l-.3-.2h-.5l-.3-.2h-.2l-.3-.1-.2-.1h-.3l-.2-.2h-.2l-.3-.1-.2-.1h-.3l-.2-.2H99l-.3-.1-.2-.1-.2-.1H98l-.3-.2h-.2l-.2-.2h-.2l-.3-.1-.2-.1-.2-.1-.2-.1-.2-.1-.2-.1-.2-.1h-.2l-.2-.2H95l-.2-.2h-.2l-.2-.2h-.1l-.2-.2h-.2l-.2-.2h-.2l-.2-.2h-.2l-.2-.2h-.2l-.1-.1-.2-.1-.2-.1-.2-.1-.1-.1-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.3-.2-.3-.2-.3-.2-.2-.2-.3-.1-.3-.2-.2-.2-.3-.2-.2-.2-.3-.1-.2-.2-.2-.2-.2-.1-.2-.2-.2-.1-.2-.2-.2-.1-.2-.1-.1-.2-.2-.1-.1-.1-.2-.1-.1-.1-.1-.2-.3-.1-.1-.2-.2-.1-.1-.2h-.1l-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.1-.3-.1-.3-.1-.3-.1-.3v-.3l-.1-.4v-1.5l.2-.4v-.3l.2-.3.1-.2.2-.3.2-.3.2-.2.2-.3.2-.2.3-.2.2-.2.3-.2.3-.2h.3l.3-.2.3-.1.3-.1h.3l.3-.1h1.3l.3.1h.3l.3.2.3.1.3.2.3.1.2.2.3.2.2.2.1.1h.1l.1.2.2.1.1.1.1.1.1.1.2.1v.1l.2.1.1.1.2.1.1.1.2.2h.1l.2.2.2.1.2.2.2.1.2.1.2.2.2.1.2.2.2.1.2.2.3.1.2.2.3.1.2.2.3.1.2.2.3.1.1.1h.2l.1.2h.2l.1.1h.2l.1.2h.1l.2.1.1.1h.2l.2.2h.1l.2.1h.1l.2.2h.1l.2.1h.2l.1.2h.2l.2.1.3.2h.2l.1.1h.2l.2.1.2.1h.1l.2.2h.4l.2.2h.3l.2.2h.4l.2.2h.3l.2.1.2.1h.2l.2.1h.2l.2.1h.2l.2.1h.2l.2.1h.2l.2.1h.2l.2.1h.2l.2.1h.3l.2.1h.2l.2.1h.4l.2.1h.5l.2.1h.4l.2.1h.7l.2.1h.7l.3.1h5.5l.3-.1h.5l.2-.1h.5l.3-.1h.3l.2-.1h.3l.2-.1h.3l.3-.1h.2l.3-.1h.3l.2-.1.3-.1h.3l.2-.2h.3l.3-.1h.3l.2-.2h.3l.3-.1.3-.1.2-.1.3-.1.3-.1.3-.1.3-.1.3-.1.2-.1.3-.1.3-.2h.3l.3-.2.3-.1.3-.1.3-.2.3-.1.3-.1.3-.2.2-.1.3-.2.3-.1.3-.2.3-.1.3-.2.3-.2.3-.1.4-.2.3-.2.3-.1.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2.4-.2.3-.2.3-.2.3-.3.3-.2.3-.2.4-.2.3-.3.3-.2.3-.2.3-.2.2-.1.3-.2h.3l.3-.2h.7l.3-.1h.6z"
          fill="#253b59"
        />
        <defs>
          <linearGradient
            id="a"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(184.861 147.565 -135.5 201.321 18.9 14.7)"
          >
            <stop offset="0%" stop-color="#b476ff" />
            <stop offset="22%" stop-color="#ffb69c" />
            <stop offset="22%" stop-color="#ffda90" />
            <stop offset="53%" stop-color="#fff" />
            <stop offset="53%" stop-color="#73ffd5" />
            <stop offset="81%" stop-color="#a1eeff" />
            <stop offset="100%" stop-color="#e4fffa" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default Icon;
